var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"appHeight":_vm.appHeight}},[_c('router-view',{attrs:{"siteLanguage":_vm.siteLanguage,"faqLink":_vm.faqLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }